/* eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'
import CoverageDash from './views/CoverageDash.vue'
import FinReport from './views/FinReport.vue'
import NewFinReport from './views/NewFinReport.vue'
import Home from '@/views/Home.vue'
import NotFound from '@/views/NotFound.vue'
import Login from '@/views/Login.vue'
import SignUp from '@/views/SignUp.vue'
import firebase from 'firebase/app'
import ForgotPassword from '@/views/ForgotPassword.vue'
import ForbiddenPage from '@/views/ForbiddenPage.vue'
import UserRoleEdit from '@/views/UserRoleEdit.vue'
import Movimentacoes from '@/views/Movimentacoes.vue'
import CadastroCotistas from '@/views/CadastroCotistas.vue'
import RotinasComercial from '@/views/RotinasComercial.vue'
import Distribuidoras from '@/views/Distribuidoras.vue'
import InternalError from '@/views/InternalError.vue'
import RebateRegras from '@/views/RebateRegras.vue'
import RebateCalculo from '@/views/RebateCalculo.vue'
import GerarMultipagers from '@/views/GerarMultipagers.vue'
import MonitorAcoes from '@/views/MonitorAcoes.vue'
import RotinaEnvioArquivosSemanal from '@/views/RotinaEnvioArquivosSemanal'
import RotinaEnvioExtratoComercial from '@/views/RotinaEnvioExtratoComercial'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/coverageDash',
      name: 'coverageDash',
      component: CoverageDash,
      meta: {
        title: 'LEQ - Dashboard Cobertura',
        requiresAuth: true,
        roles: ['default','admin']
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'LEQ - Login',
        requiresAuth: false,
        roles: []
      }
    },
    {
      path: '/userRoleEdit',
      name: 'userRoleEdit',
      component: UserRoleEdit,
      meta: {
        title: 'LEQ - Perfis de Usuários',
        requiresAuth: true,
        roles: ['admin', 'new_user']
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: 'LEQ - Home',
        requiresAuth: true,
        roles: ['default','admin', 'new_user']
      }
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: SignUp,
      meta: {
        title: 'LEQ - Sign Up',
        requiresAuth: false,
        roles: []
      }
    },
    {
      path: '/forbiddenPage',
      name: 'forbiddenPage',
      component: ForbiddenPage,
      meta: {
        title: 'LEQ - Forbidden Page',
        requiresAuth: true,
        roles: ['default','admin','new_user']
      }
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: ForgotPassword,
      meta: {
        title: 'LEQ - Sign Up',
        requiresAuth: false,
        roles: []
      }
    },
    {
      path: '/finReport',
      name: 'finReport',
      component: FinReport,
      meta: {
        title: 'LEQ - Financial Report',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/monitorAcoes',
      name: 'monitorAcoes',
      component: MonitorAcoes,
      meta: {
        title: 'LEQ - Monitor Ações',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/newfinreport',
      name: 'newfinreport',
      component: NewFinReport,
      meta: {
        title: 'LEQ - Financial Report',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/cadastroCotistas',
      name: 'cadastroCotistas',
      component: CadastroCotistas,
      meta: {
        title: 'LEQ - Cadastro de Clientes',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/movimentacoes',
      name: 'movimentacoes',
      component: Movimentacoes,
      meta: {
        title: 'LEQ - Movimentações',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/distribuidoras',
      name: 'distribuidoras',
      component: Distribuidoras,
      meta: {
        title: 'LEQ - Distribuidoras',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/rotinasComercial',
      name: 'rotinasComercial',
      component: RotinasComercial,
      meta: {
        title: 'LEQ - Cadastro de Clientes',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    // {
    //   path: '/rotinaEnvioArquivosSemanal',
    //   name: 'rotinaEnvioArquivosSemanal',
    //   component: RotinaEnvioArquivosSemanal,
    //   meta: {
    //     title: 'LEQ - Arquivos Semanais',
    //     requiresAuth: true,
    //     roles: ['admin', 'default']
    //   }
    // },
    // {
    //   path: '/rotinaEnvioExtratoComercial',
    //   name: 'rotinaEnvioExtratoComercial',
    //   component: RotinaEnvioExtratoComercial,
    //   meta: {
    //     title: 'LEQ - Envio de Extratos',
    //     requiresAuth: true,
    //     roles: ['admin', 'default']
    //   }
    // },
    {
      path: '/internalError',
      name: 'internalError',
      component: InternalError,
      meta: {
        title: 'LEQ - Sign Up',
        requiresAuth: false,
        roles: []
      }
    },
    {
      path: '/rebateRegras',
      name: 'rebateRegras',
      component: RebateRegras,
      meta: {
        title: 'LEQ - Rebate Regras',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/rebateCalculo',
      name: 'rebateCalculo',
      component: RebateCalculo,
      meta: {
        title: 'LEQ - Rebate Cálculo',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '/gerarMultipagers',
      name: 'gerarMultipagers',
      component: GerarMultipagers,
      meta: {
        title: 'LEQ - Gerar Multipagers',
        requiresAuth: true,
        roles: ['admin', 'default']
      }
    },
    {
      path: '**',
      name: 'notFound',
      component: NotFound,
      meta: {
        title: 'LEQ - Not Found',
        requiresAuth: false,
        roles: []
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {

  document.title = to.meta.title
  
  const currentUser = firebase.auth().currentUser
  let userRole;
  
  if(currentUser) {
    try{
      const idTokenResult = await currentUser.getIdTokenResult();
      userRole = idTokenResult.claims.role;
      userRole = (userRole === undefined ?  'new_user' : userRole)
    } catch (err) {
      this.$alert('Erro ao consultar perfil do usuário').
      next('internalError')
    }
  }
  
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const permittedUser = to.matched.some(record => record.meta.roles.includes(userRole))
  
  if (!requiresAuth) {
    next()
  } else if (requiresAuth && !currentUser) {
    next('login')
  } else if(currentUser && !permittedUser) {
    next('home')
    // dar alerta na tela
  } else {
    next()
  }
  
})

export default router
